<template>
  <div
    class="cursor-pointer"
    @click.stop="
      router.push({
        name: `collectionMain`,
        params: { uuid: collection.uuid },
      })
    "
  >
    <div class="flex gap-2.5">
      <div class="w-[100px]">
        <BaseImg :media="collection.coverMedia" :width="200" ratio="1/1" />
      </div>
      <div class="flex-1 flex flex-col justify-between">
        <h3 class="text-base font-bold line-clamp-1">{{ collection.title }}</h3>

        <p
          class="line-clamp-3 text-xs text-my-gray flex-1 max-h-[50px] overflow-hidden"
        >
          {{ collection.description }}
        </p>
        <p class="text-xs text-my-gray">
          {{
            $t(`collection.count`, {
              momentCount: collection.momentCount,
              storyCount: collection.storyBookCount,
              gameCount: collection.galGameCount,
            })
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Collection } from "@/types/collection";
import { PropType } from "vue";
import { useRouter } from "vue-router";

defineProps({
  collection: {
    type: Object as PropType<Collection>,
    required: true,
  },
});
const router = useRouter();
</script>
